<div class="flex items-center gap-2 mb-3 text-sm font-bold uppercase tracking-wider text-gray-600">
  <i nz-icon nzType="calendar" nzTheme="outline"></i>
  <span>{{'calendar.specialProcedures' | translate}}</span>
  <span class="flex-1 h-px bg-gray-200"></span>
  <button [disabled]="!serviceId || viewOnly || bookingStatus == 2" nz-button nzSize="small" (click)="addEditService()">
    <i nz-icon nzType="plus"></i>
  </button>
</div>
<div nz-row [nzGutter]="[8, 8]" class="overflow-row">
  @for (item of serviceSpecs; track item.serviceId; let i = $index) {
    <div nz-col [nzSpan]="24">
      <nz-card>
        <div nz-row nzJustify="space-between">
          <div nz-col>
            {{ item?.service?.name }}
          </div>
          <div nz-col>
            @if (item.salaryPercent) {
              <i
                nz-icon
                [nz-tooltip]="item.employeeName"
                nzType="user"
                nzTheme="outline"
                style="color: #1890ff"
              ></i>
              {{ item.salaryPercent }} %
            } @else {
              <i
                nz-icon
                nzType="user"
                nzTheme="outline"
                style="color: #1890ff"
              ></i>
              {{ item.salaryFixed }} {{'calendar.form.gel' | translate}}
            }
            <nz-divider nzType="vertical"></nz-divider>
            <i
              nz-icon
              nzType="money-collect"
              nzTheme="outline"
              style="color: #1890ff"
            ></i>
            {{ item.price }} {{'calendar.form.gel' | translate}}
          </div>
        </div>
        <div nz-row nzFlex="auto" nzJustify="space-between">
          <div nz-col>
            @for (serviceProduct of item.serviceProducts; track serviceProduct) {
              <nz-tag
                [nzColor]="'blue'"
                >
                <nz-space [nzSize]="8">
                  <div *nzSpaceItem>
                    {{ serviceProduct?.productMeta?.name }}
                  </div>
                  @if (serviceProduct.quantitySum) {
                    <span *nzSpaceItem
                      >{{ serviceProduct.quantitySum }} {{'calendar.form.gel' | translate}}</span
                      >
                      @if (serviceProduct.grSum) {
                        <span
                          >{{ serviceProduct.grSum }}  {{'calendar.form.gram' | translate}}</span
                          >
                        }
                      }
                    </nz-space>
                  </nz-tag>
                }
              </div>
              <div nz-col>
                <nz-space [nzSize]="8">
                  @if (!viewOnly && bookingStatus != 2) {
                    <i *nzSpaceItem
                      nz-icon
                      nzType="edit"
                      nzTheme="outline"
                      style="cursor: pointer"
                      (click)="addEditService(item)"
                    ></i>
                  }
                  @if (!viewOnly && bookingStatus != 2) {
                    <i *nzSpaceItem
                      nz-popconfirm
                      nzPopconfirmTitle="{{'buttons.deletePop' | translate}}"
                      nzPopconfirmPlacement="bottom"
                      (nzOnConfirm)="delete(i)"
                      nz-icon
                      nzType="delete"
                      nzTheme="outline"
                      style="cursor: pointer"
                    ></i>
                  }
                </nz-space>
              </div>
            </div>
          </nz-card>
        </div>
      }
    </div>
